// extracted by mini-css-extract-plugin
export var overlay = "category-card-module--overlay--1DBZD";
export var title = "category-card-module--title--lGKFH";
export var summary = "category-card-module--summary--S__HD";
export var heroOverlay = "category-card-module--hero-overlay--2eyWl";
export var button = "category-card-module--button--2dmWE";